import { render, staticRenderFns } from "./AliareSelect.vue?vue&type=template&id=ec85ea1a&scoped=true&"
import script from "./AliareSelect.vue?vue&type=script&lang=ts&"
export * from "./AliareSelect.vue?vue&type=script&lang=ts&"
import style0 from "./AliareSelect.vue?vue&type=style&index=0&id=ec85ea1a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec85ea1a",
  null
  
)

export default component.exports